import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tab,
  Tabs,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useDispatch, useSelector } from "react-redux";
import { getWhiteLabel } from "../../actions/cities";
import { useLocalStorage } from "../../hooks";
import { strings } from "../../I18n";
import { isDevEnvironment } from "../../utils/environment";
import { isSuperAdmin } from "../../utils/utils";
import AppVersionTab from "./AppVersionTab";
import UserRestrictionsTab from "./UserRestrictionsTab";

const SettingsContainer = () => {
  const dispatch = useDispatch();
  const { adminDetails } = useSelector((state) => state.auth);
  const whiteLabels = useSelector((state) => state.cities.whiteLabels);

  const [tab, setTab] = useState(0);
  const [whitelabel, setWhitelabel] = useLocalStorage(
    "whitelabelName",
    isSuperAdmin(adminDetails) ? "sharebike" : adminDetails.whiteLabelCode
  );

  useEffect(() => {
    dispatch(getWhiteLabel());
  }, [dispatch]);

  const getWhiteLabelId = () => {
    if (whiteLabels && whiteLabels.length > 0) {
      const wl = whiteLabels.find((w) => w.code === whitelabel);
      if (wl) return wl.id;
    }
    return null;
  };

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <div className="settings-container">
      {isSuperAdmin(adminDetails) && (
        <FormControl variant="outlined" style={{ width: "100%" }}>
          <InputLabel shrink={true}>
            {strings("message.selectWhitelabel")}
          </InputLabel>
          <Select
            value={whitelabel}
            label={strings("message.selectWhitelabel")}
            onChange={(e) => setWhitelabel(e.target.value)}
          >
            <MenuItem value={"sharebike"}>
              {isDevEnvironment() ? "Shematic" : "Lisa"}
            </MenuItem>
            <MenuItem value={"bigIssue"}>Bigissue</MenuItem>
            <MenuItem value={"esb"}>ESB</MenuItem>
            <MenuItem value={"farteBysykkel"}>Farte</MenuItem>
            <MenuItem value={"sigo"}>Sigo</MenuItem>
            <MenuItem value={"sefa"}>Sefa</MenuItem>
            <MenuItem value={"weelz"}>Weelz</MenuItem>
            <MenuItem value={"gjovik"}>Gjøvik</MenuItem>
            <MenuItem value={"lisa-demo"}>LISA Demo</MenuItem>
          </Select>
        </FormControl>
      )}

      <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 3 }}>
        <Tabs value={tab} onChange={handleTabChange}>
          <Tab label={strings("settings.appVersion") || "App Version"} />
          <Tab
            label={strings("settings.userRestrictions") || "User Restrictions"}
          />
        </Tabs>
      </Box>

      {tab === 0 && <AppVersionTab whitelabel={whitelabel} />}
      {tab === 1 && <UserRestrictionsTab whiteLabelId={getWhiteLabelId()} />}
    </div>
  );
};

export default SettingsContainer;
